export default __webpack_public_path__ + "static/media/i-speedometer_sura.40f492e9.svg";